﻿import LfDataService from '../../../Services/LfDataService';

import {
    pageIsLoadingAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';

export function loadTravelCertPageDataAction() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        lfDataService.customerInfo()
            .then(data => {
                dispatch(travelCertPageLoadedAction({
                    customerInfo: data.customer,
                    coinsuredInfo: data.currentCoInsured,
                    travelCertificateUrl: lfDataService.generatedTravelCertificateUrl,
                    mailSentStatus: false
                }));

                dispatch(pageIsLoadingAction(false));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export function travelCertPageLoadedAction(data) {
    return {
        type: 'TRAVEL_CERT_PAGE_LOADED',
        data
    };
}

export function mailTravelCertAction() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        dispatch(travelCertMailSentStatusAction(false));
        dispatch(pageIsLoadingAction(true));

        lfDataService.mailTravelCertificate()
            .then(result => {
                if (result.success) {
                    dispatch(travelCertMailSentStatusAction(true));
                    dispatch(pageIsLoadingAction(false));

                    return;
                }

                dispatch(pageIsLoadingAction(false));
                dispatch(pageErrorAction('kunde inte skicka resebevis'));
                dispatch(pageHasErroredAction(true));
            })
            .catch(e => {
                dispatch(pageIsLoadingAction(true));
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}

export function travelCertMailSentStatusAction(travelCertMailSent) {
    return {
        type: 'TRAVEL_CERT_PAGE_MAIL_SENT_STATUS',
        travelCertMailSent
    };
}